module.exports = __webpack_public_path__ + "img/icn_report.73871f22.svg";